import { isWindowDefined } from "@huub-web/utils";

import type { ContentMenuSection } from "../../../contexts/ContentMenuContext";

/**
 * Sort sections by their actual position in the DOM
 * This ensures menu items appear in the correct order even when added asynchronously
 * @param sections - Array of sections to sort
 * @param direction - Sort direction: "vertical" for page scroll, "horizontal" for carousel
 */
export const sortSectionsByDOMPosition = (
  sections: ContentMenuSection[],
  direction: "vertical" | "horizontal" = "vertical",
): ContentMenuSection[] => {
  if (!isWindowDefined()) {
    return sections;
  }

  return [...sections].sort((a, b) => {
    if (!a.ref.current || !b.ref.current) {
      return 0;
    }

    if (direction === "horizontal") {
      return a.ref.current.offsetLeft - b.ref.current.offsetLeft;
    }

    const aPosition =
      a.ref.current.getBoundingClientRect().top + window.pageYOffset;
    const bPosition =
      b.ref.current.getBoundingClientRect().top + window.pageYOffset;

    return aPosition - bPosition;
  });
};
